import "./App.css";
import LandingPage from "./components/LandingPage/landingPage";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { loginRequest, apiRequest } from "./auth-config";
import React from "react";
import DefaultContainer from "./Route";
import useNetworkStatus from "./components/networkStatus/useNetworkStatus";

const App = () => {
  useNetworkStatus();
  const request = indexedDB.open("DNA_Pathogen_Tracker", 1);
  request.onupgradeneeded = (event) => {
    let db = event.target.result;
    db.createObjectStore("org_sample", {
        autoIncrement: true,
     })
    }
  return (
    <div className="App">
        <Router>
          <Switch>
            <Route
              exact
              path="/"
              component={() => (
                <LandingPage
                  loginRequest={loginRequest}
                  apiRequest={apiRequest}
                />
              )}
            />
            <Route component={() => <DefaultContainer />} />
          </Switch>
        </Router>
    </div>
  );
};
export default App
